var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTelegramIcon = function SvgTelegramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.877 15.088a.94.94 0 0 0 .846.107.862.862 0 0 0 .553-.616c.664-2.995 2.274-10.576 2.878-13.3a.56.56 0 0 0-.198-.556.632.632 0 0 0-.61-.103C15.145 1.758 5.28 5.311 1.249 6.744a.607.607 0 0 0-.414.586c.01.26.191.484.453.56C3.095 8.409 5.47 9.13 5.47 9.13s1.109 3.216 1.687 4.851c.073.206.24.367.46.423a.682.682 0 0 0 .62-.152l2.365-2.144s2.729 1.921 4.276 2.98Zm-8.41-6.363 1.283 4.061.285-2.572 7.78-6.736a.198.198 0 0 0 .025-.276.223.223 0 0 0-.287-.047l-9.086 5.57Z",
    fill: "#000"
  })));
};

export default SvgTelegramIcon;